import { QueryFunctionContext } from '@tanstack/react-query';

import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const QUERY_KEY = 'relevance_test_definitions';

export const queryRelevanceTestDefinitions = (
    context: QueryFunctionContext<App.RelevanceTestDefinitions.QueryKey, number>,
): Promise<Models.PageResult<Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition>> => {
    const { queryKey } = context;
    const [, accessToken, search] = queryKey;
    const { offset, limit } = search;

    return RelevanceTestsService.getRelevanceTestDefinitions(
        accessToken,
        search,
        offset,
        limit,
    );
};
